const { colors } = require("../theme/colors")
const pages = require("./pages")
const shortName = 'Plusuno'
const companyName = 'Plusuno Inc.'
const companyNameJp = 'ぷらすの株式会社'
const description = 'Plusuno is a lifestyle development company. We create apps to help life fun, comfortable & stressless.'
module.exports = {
  pages,
  companyName: companyName,
  author: companyName,
  companyInfo: [
    {
      name: 'Name',
      content: companyName
    },
    {
      name: 'Corporate Number',
      content: 2011101079929
    },
    {
      name: 'Address',
      content: '2-12-13, SHINJUKU<br />SHINJUKU ANTRE SALON BLDG. 2F.<br />SHINJUKU-KU, TOKYO 160-0022'
    },
  ],
  companyInfoJp: [
    {
      name: '会社名',
      content: companyNameJp
    },
    {
      name: '法人番号',
      content: 2011101079929
    },
    {
      name: '所在地',
      content: '東京都新宿区新宿2-12-13 アントレサロンビル2F'
    },
  ],
  Address: {
    position: { lat: 35.6906018, lng: 139.7079907 },
  },
  site: {
    title: {
      default: 'Podcast +1 - Simple Podcast App',
      template: 'Podcast +1',
      templateSeparator: ' | ', // ["|", "-"]
      templatePosition: 'end', // ['start', 'end']
    },
    keywords: 'Podcast +1, Podcast App, Simple Poddcast App, Plusuno, Plusuno Inc., ',
    description,
    url: `https://www.podcast-plus1.com`,
    sitemap: `https://www.podcast-plus1.com/sitemap.xml`,
    manifest: {
      name: companyName,
      short_name: shortName,
      description,
      start_url: '/',
      background_color: colors.background,
      theme_color: colors.theme,
      display: "minimal-ui",
      orientation: "portrait",
    },
  },
  GoogleMap: {
    placeId: 'ChIJSXcgydyMGGAR63elql-vXhs',
    API_KEY: process.env.NODE_ENV === "development" ? '' : 'AIzaSyC9IauuEKNSnhN-kPBRCBpWZ4i2DKQBsQc',
    zoom: 14, // 4 for international, 14 for internal
  },
  GoogleAnalytics: {
    trackingId: 'UA-115798364-1'
  },
  SECRET_KEY_BASE: '91edf02658bb125397ad48eb8ccce01f0a446c30902e79d4af7aac8e06012412544bac1475e5df5181d6ef8a9df33ac73ffde445c93114a899fe871e1fa0db99',
  SLACK_WEBHOOK_URL: 'https://hooks.slack.com/services/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',
  DEFAULT_EMAIL: 'noreply@plusuno.jp',
  ADMIN_EMAIL: 'k.o1@plusuno.jp',
  DOMAIN: 'plusuno.jp',
  SENDGRID_API_KEY: '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',
}


// WEBPACK FOOTER //
// ./src/config/settings.js